<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/05-JS-craft-your-resume.svg"
                class="img-fluid"
                alt="Craft your resume"
                srcset=""
              >
            </h1>
          </div>
          <div class="col-md-5">
            <!-- <img
                src="@/assets/img/_content/5.AdobeStock_328237788.png"
                class="img-fluid"
                alt="Craft your resume"
                srcset=""
              > -->
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->

    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row">
        <!-- <div class="col-md bg-img bg-img--test-01">
          <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          >
        </div> -->
        <div class="p-4">
          <!-- <h2 class="content-block__header">What do I have to offer?</h2> -->
          <p>A resume is basically a marketing tool designed to get you a job interview. To that end, it should only include information that is <strong>relevant to the job you are applying for</strong>. That means updating your resume for every new job you apply to.</p>
          <p>Answer these 4 questions before you begin updating your resume…</p>
            <div class="carousel carousel--green">
              <hooper
                ref="carousel_01"
                class="mb-4"
              >
                <slide>
                  <div class="slide">
                    <p>What am I using this resume for? Is it for a frontline/customer-facing role? Is it for an admin position? Is it for research?</p>
                  </div>
                </slide>

                <slide>
                  <div class="slide">
                    <p>What skills have I gained through my schooling (think of courses, labs, projects, presentations) that might be relevant to the job I’m applying for?</p>
                  </div>
                </slide>

                <slide>
                  <div class="slide">
                    <p>What other relevant work, volunteer and other life experiences can I share? This could include international experience, freelance work, internships, placements and co-op experiences.</p>
                  </div>
                </slide>

                <slide>
                  <div class="slide">
                    <p>What skills do employers most commonly look for?</p>
                  </div>
                </slide>

                <hooper-navigation slot="hooper-addons">
                  <img
                    slot="hooper-prev"
                    src="@/assets/img/_ui/svg/carousel-back--green.svg"
                    alt="previous"
                    srcset=""
                  >
                  <img
                    slot="hooper-next"
                    src="@/assets/img/_ui/svg/carousel-next--green.svg"
                    alt="next"
                    srcset=""
                  >
                </hooper-navigation>

                <hooper-pagination slot="hooper-addons"></hooper-pagination>
              </hooper>
            </div>
          <p class="pt-3">Once you understand the goal of your resume, it’ll be much easier to format it to target the positions you want.</p>
        </div>
      </div>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    // Accordion,
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
